import { sendRail } from "~/features/configurator/Rail/api/sendRailCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { buildConfiguratorNavigationCommand } from "~/features/configurator/common/api/configuratorCommands";

export function sendRailStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  return sendRail(buildConfiguratorNavigationCommand(linearState));
}
